const e = {
  baseMarker: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center"
  },
  marker: {
    flexShrink: 0
  }
};
export {
  e as styles
};
